<form [formGroup]="form" (ngSubmit)="submitForm()" class="grid md:grid-cols-2 grid-cols-1 gap-y-1 gap-x-2">

    <mat-form-field class="col-span-2 w-full" appearance="outline">
      <mat-label>BRELA Number</mat-label>
      <input matInput formControlName="companyID"/>
      <mat-error *ngIf="form.get('companyID')?.hasError('required')">
        BRELA Number is required
      </mat-error>
    </mat-form-field>

  <mat-form-field class="col-span-1 w-full" appearance="outline">
    <mat-label>First Name</mat-label>
    <input matInput formControlName="firstName"/>
    <mat-error *ngIf="form.get('firstName')?.hasError('required')">
      First name is required
    </mat-error>
  </mat-form-field>

  <mat-form-field class="col-span-1 w-full" appearance="outline">
    <mat-label>Last Name</mat-label>
    <input matInput formControlName="lastName"/>
    <mat-error *ngIf="form.get('lastName')?.hasError('required')">
      Last name is required
    </mat-error>
  </mat-form-field>

  <mat-form-field class="col-span-1 w-full" appearance="outline">
    <mat-label>Phone Number</mat-label>
    <input matInput formControlName="phoneNumber" mask="000-000-000-000" placeholder="255-___-___-___"/>
    <mat-error *ngIf="form.get('phoneNumber')?.hasError('required')">
      Phone number is required
    </mat-error>
    <mat-error *ngIf="form.get('phoneNumber')?.hasError('pattern')">
      Phone number is incorrect
    </mat-error>
  </mat-form-field>

  <mat-form-field class="col-span-1 w-full" appearance="outline">
    <mat-label>Email(In BRELA directors list)</mat-label>
    <input matInput formControlName="email"/>
    <mat-error *ngIf="form.get('email')?.hasError('required')">
      Email is required
    </mat-error>
    <mat-error *ngIf="form.get('email')?.hasError('email')">
      Invalid email format
    </mat-error>
  </mat-form-field>


  <div class="md:col-span-2 col-span-1">
    <mat-checkbox formControlName="consent">
      <div class="flex flex-col">
        <p class="font-bold border-b pb-1">Consent</p>
        <span [innerHTML]="privacyPolicyText"></span>
      </div>
    </mat-checkbox>
    <mat-error *ngIf="form.get('consent')?.hasError('required')">
      You must agree to the <a class="underline text-primary-600" href="/privacy-policy" target="_blank">privacy
      policy</a>.
    </mat-error>
  </div>

  <div class="md:col-span-2 col-span-1 mt-1">
    <button mat-raised-button color="primary" class="w-full py-3" type="submit" [disabled]="form.invalid">
      Save
    </button>
  </div>
</form>
